import {ref} from "vue";

const STORAGE_KEY = 'eodsun:wakeLock';

export const wakeLockSupported = ('wakeLock' in navigator);

export const wakeLockActive = ref(false);
let wakeLockPending = false;
let wakeLockSentinel = null;

export function toggleWakeLock() {
    if (!wakeLockSupported) {
        return;
    }
    if (wakeLockPending) {
        return;
    }

    if (wakeLockActive.value) {
        releaseWakeLock();
    } else {
        requestWakeLock();
    }
}

function requestWakeLock() {
    if (wakeLockSentinel !== null) {
        return;
    }

    wakeLockPending = true;
    navigator.wakeLock.request('screen')
        .then((wakeLock) => {
            wakeLockSentinel = wakeLock;
            wakeLockActive.value = true;
            sessionStorage.setItem(STORAGE_KEY, '1');
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            wakeLockPending = false;
        });
}

function releaseWakeLock() {
    if (wakeLockSentinel === null) {
        return;
    }

    wakeLockPending = true;
    wakeLockSentinel.release()
        .then(() => {
            wakeLockActive.value = false;
            wakeLockSentinel = null;
            sessionStorage.removeItem(STORAGE_KEY);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            wakeLockPending = false;
        });
}

if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    requestWakeLock();
}
